/** User-facing causes; provider response bodies never belong in the dialog. */
export function voiceFailureMessage(code?: string | null): string {
  const suffix = " Ihr Diktat wurde nicht übernommen.";
  switch (code) {
    case "empty_transcript":
      return "In der Aufnahme wurde kein Text erkannt. Bitte sprechen Sie das Diktat erneut ein.";
    case "service_authentication_failed":
    case "service_configuration_error":
      return "Die Sprachauswertung ist wegen einer technischen Konfigurationsstörung nicht verfügbar. Bitte wenden Sie sich an den Support." + suffix;
    case "provider_quota_exhausted":
      return "Die Sprachauswertung ist für den Dienst derzeit gesperrt. Bitte wenden Sie sich an den Support." + suffix;
    case "upstream_rate_limited":
      return "Die Sprachauswertung ist derzeit ausgelastet. Bitte versuchen Sie es in einigen Minuten erneut." + suffix;
    case "upstream_timeout":
      return "Die Sprachauswertung hat nicht rechtzeitig geantwortet. Bitte versuchen Sie es erneut." + suffix;
    case "upstream_unavailable":
      return "Der Dienst zur Sprachauswertung ist derzeit nicht erreichbar. Bitte versuchen Sie es später erneut." + suffix;
    case "upstream_invalid_response":
      return "Der Dienst zur Sprachauswertung hat ein ungültiges Ergebnis geliefert. Bitte wenden Sie sich an den Support." + suffix;
    case "interpretation_failed":
      return "Ihre Sprache wurde erkannt, konnte aber nicht in eine Notiz oder Aufgabe umgesetzt werden. Bitte versuchen Sie es erneut." + suffix;
    default:
      return "Die Sprachauswertung ist fehlgeschlagen. Die Ursache konnte nicht genauer bestimmt werden. Bitte wenden Sie sich an den Support." + suffix;
  }
}
